import { warn } from '@execonline-inc/logging';
import { URLParser, putQueryParam, toUrlT } from '@execonline-inc/url';
import { valueFor } from '../../../ListFilter';
import { SearchParameter, SearchParameters } from '../../../ListFilter/Types';
import { Link } from '../../../Resource/Types';
import { sortOptionValueDecoder } from '../Decoders';
import { SortIntention, SortOptionValue, SortParam } from '../Types';

const toSortIntention = (value: SortOptionValue): SortIntention => {
  switch (value) {
    case 'name-asc':
      return ['name', 'asc'];
    case 'name-desc':
      return ['name', 'desc'];
    case 'updated_at-asc':
      return ['updated_at', 'asc'];
    case 'updated_at-desc':
      return ['updated_at', 'desc'];
  }
};

const toSortParams = ([sortBy, sortDirection]: SortIntention): ReadonlyArray<SortParam> => [
  { key: 'sort_by', value: sortBy },
  { key: 'sort_direction', value: sortDirection },
];

const decodeSortParameters = (sortParameters: SearchParameters) => {
  const sortValue = valueFor('sort', sortParameters);
  // Don't log warnings for missing/empty sort parameters (expected on initial load)
  if (!sortValue || sortValue === '') {
    return [];
  }
  return sortOptionValueDecoder
    .decodeAny(sortValue)
    .map(toSortIntention)
    .map(toSortParams)
    .elseDo((e) => warn(`Error trying to decode sort parameters ${e}`))
    .getOrElseValue([]);
};

const addFilterParam = (acc: URLParser, parameter: SearchParameter) =>
  putQueryParam(`learning_collections_filter[${parameter.key}]`, parameter.value, acc);

const buildQueryString =
  (searchParameters: SearchParameters, sortParameters: SearchParameters) => (url: URLParser) =>
    searchParameters.concat(decodeSortParameters(sortParameters)).reduce(addFilterParam, url);

export const assignSearchParameters =
  (page: number, searchParameters: SearchParameters, sortParameters: SearchParameters) =>
  (link: Link) =>
    toUrlT(link.href)
      .map(buildQueryString(searchParameters, sortParameters))
      .map(putQueryParam('page', String(page)))
      .map((urlParser) => ({ ...link, href: urlParser.href }));
